import React, {useEffect} from 'react'
import PropTypes from 'prop-types'
import FAQ from '../faq/FAQ'
import {getI18nTextWithContext, getI18nTextWithParentKey} from "wipi-common/src/lib/i18n";
import MethodTitle from '../misc/Method-title/MethodTitle'
import ContinueInBrowser from './ContinueInBrowser'
import ShortCaseInfo from '../misc/ShortCaseInfo'
import BackToMethodSelectionButton from '../misc/BackToMethodSelectionButton'
import {LOG_EVENTS} from 'wipi-common/src/lib/logging/events'
import './StartEid.scss'
import LOG from "wipi-common/src/lib/logging/logger"
import {useI18nContext} from "../i18n/I18nContext"
import InstallAppBanner from "../misc/InstallAppBanner";
import eidIlluDark from '../../assets/illustrations/eid-description-dark.svg'
import eidIlluLight from '../../assets/illustrations/eid-description-light.svg'

export default function StartEId({caseInfo, isMobileDevice, tcTokenUrlHost}) {
    const context = useI18nContext()

    // Temporary solution to hide the continue button if eid ident has a DIU phase
    let v1bWorkflow = caseInfo.modules.identMethodSelection.methodChoice.find(method => {
        return method.method === 'eid'
    }).forceUpdate;

    let availability = caseInfo.modules.identMethodSelection.methodChoice.find(method => {
      return method.method === 'eid'
    }).footer;

    useEffect(() => {
        LOG.logInfo(LOG_EVENTS.PD_START_EID)
    }, [context])

    return <>
        <div className="headless">
            <div className="col-xl-6 col-lg-6 col-md-8 col-sm-12 offset-lg-3 offset-md-2">
               <MethodTitle
                   heading={getI18nTextWithContext(context, 'startEId.heading')}
                   subHeading={getI18nTextWithContext(context, 'eIdStart.subtitle')}
                   info={getI18nTextWithContext(context, 'eIdStart.description')}
                   testId="32cba09d-513b"/>
                <InstallAppBanner
                    caseId={caseInfo.caseId}
                    isMobileDevice={isMobileDevice}
                    availability={availability}
                    illustrationLight={eidIlluLight}
                    illustrationDark={eidIlluDark}/>
                <ContinueInBrowser
                    caseId={caseInfo.caseId} isMobileDevice={isMobileDevice}
                    signingWorkFlow={caseInfo.signingWorkFlow}
                    v1bWorkflow={v1bWorkflow}
                    tcTokenUrlHost={tcTokenUrlHost} />
                <BackToMethodSelectionButton caseInfo={caseInfo} isMobileDevice={isMobileDevice}/>
            </div>
            <ShortCaseInfo caseId={caseInfo.caseId} bcName={caseInfo.principalDisplayName}/>
        </div>
        <FAQ faq={getI18nTextWithParentKey(context, 'startEId.faq')}/>
    </>
}

StartEId.propTypes = {
    caseInfo: PropTypes.shape({
        caseId: PropTypes.string.isRequired,
        signingWorkFlow: PropTypes.string,
        principalDisplayName: PropTypes.string,
        modules: PropTypes.shape({
            identMethodSelection: PropTypes.shape({
                methodChoice: PropTypes.arrayOf(PropTypes.shape({
                    method: PropTypes.string,
                    forceUpdate: PropTypes.bool
                }))
            })
        })
    }).isRequired,
    isMobileDevice: PropTypes.bool.isRequired,
    tcTokenUrlHost: PropTypes.string.isRequired
}
